import React from 'react'
import { Typography } from '@mui/material'
import Link from '../../../link'
import { routes } from '../../../../routes'
import Alert, { AlertTitle } from '../../../alert'

const LpqAlert = ({ severity, title, text, linkTitle }) => {
  return (
    <Alert severity={severity} showClose>
      <AlertTitle>{title}</AlertTitle>
      <Typography paragraph>{text}</Typography>
      <Link to={routes.profile.path} underline='always' variant='body1'>
        {linkTitle}
      </Link>
    </Alert>
  )
}

const CustomiseAlert = () => {
  return (
    <LpqAlert
      severity='info'
      title='Mindtools is made for you'
      text='Customise your experience by responding to some questions about you.'
      linkTitle='Customize my experience'
    />
  )
}

const PersonaliseAlert = () => {
  return (
    <LpqAlert
      severity='success'
      title='Your experience is personalized'
      text='You can update your interests at any time on your profile settings.'
      linkTitle='Profile settings'
    />
  )
}

export { CustomiseAlert, PersonaliseAlert }
